import luMarkdown from "./lu-markdown";
luMarkdown.install = function(Vue) {
  Vue.component(luMarkdown.name, luMarkdown);
};

export default luMarkdown;
